/* eslint-disable */
function readMessage(error) {
  if (error && error.response && error.response.data && error.response.data.msg) {
    return error.response.data.msg;
  }
  if (error && error.message) {
    return error.message;
  }
  return "";
}

export function friendlyTemplateError(error, fallback) {
  const raw = String(readMessage(error) || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .trim();

  if (!raw) {
    return fallback;
  }

  const lower = raw.toLowerCase();

  if (lower.indexOf("template name is required") !== -1) {
    return "Nama template wajib diisi.";
  }
  if (lower.indexOf("template name maximum") !== -1) {
    return "Nama template maksimal 255 karakter.";
  }
  if (lower.indexOf("source_flow_id is required") !== -1) {
    return "Alur sumber wajib dipilih.";
  }
  if (lower.indexOf("source flow is not found") !== -1) {
    return "Alur sumber tidak ditemukan atau bukan milik akun ini.";
  }
  if (lower.indexOf("member is not found") !== -1) {
    return "Sesi akun tidak ditemukan. Silakan masuk kembali.";
  }
  if (lower.indexOf("auto follow up template is not found") !== -1) {
    return "Template tidak ditemukan. Muat ulang daftar template.";
  }
  if (lower.indexOf("template_id is required") !== -1) {
    return "Template tidak valid. Muat ulang daftar template.";
  }
  if (lower.indexOf("template configuration is too large") !== -1) {
    return "Konfigurasi alur terlalu besar untuk dijadikan template.";
  }
  if (lower.indexOf("template configuration is empty") !== -1) {
    return "Konfigurasi template kosong. Simpan template dari alur yang sudah lengkap.";
  }
  if (
    lower.indexOf("template step") !== -1 ||
    lower.indexOf("template source") !== -1
  ) {
    return "Konfigurasi template tidak valid. Buat template baru dari alur yang sudah benar.";
  }
  if (lower.indexOf("template must contain at least one step") !== -1) {
    return "Alur harus memiliki minimal satu pesan sebelum disimpan sebagai template.";
  }
  if (lower.indexOf("template must contain at least one contact source") !== -1) {
    return "Alur harus memiliki minimal satu sumber kontak sebelum disimpan sebagai template.";
  }
  if (lower.indexOf("template schema_version") !== -1) {
    return "Format template ini tidak didukung. Buat template baru dari alur yang valid.";
  }
  if (
    lower.indexOf("template contact group") !== -1 ||
    lower.indexOf("template contact tag") !== -1 ||
    lower.indexOf("template contact is not found") !== -1
  ) {
    return "Sumber kontak template tidak ditemukan atau bukan milik akun ini. Buat template baru dari alur dengan sumber yang valid.";
  }
  if (
    lower.indexOf("template duplicate step_order") !== -1 ||
    lower.indexOf("template duplicate source") !== -1 ||
    lower.indexOf("template configuration is invalid") !== -1
  ) {
    return "Konfigurasi template tidak valid. Buat template baru dari alur yang sudah benar.";
  }
  if (
    lower.indexOf("sender license") !== -1 ||
    lower.indexOf("license is required") !== -1 ||
    lower.indexOf("license is not") !== -1
  ) {
    return "Nomor WhatsApp pengirim tidak ditemukan atau belum aktif. Pilih nomor lain yang tersedia.";
  }
  if (lower.indexOf("flow name is required") !== -1) {
    return "Nama alur wajib diisi.";
  }
  if (lower.indexOf("data yang dikirim tidak valid") !== -1) {
    return "Data yang dikirim belum sesuai. Coba lagi.";
  }
  if (lower.indexOf("terjadi kesalahan pada server") !== -1) {
    return "Terjadi kendala saat memproses permintaan. Coba lagi.";
  }
  if (lower.indexOf("template ") === 0) {
    return fallback;
  }
  if (
    lower.indexOf("sql") !== -1 ||
    lower.indexOf("select ") !== -1 ||
    lower.indexOf("table") !== -1 ||
    lower.indexOf("column") !== -1 ||
    lower.indexOf("backend") !== -1 ||
    lower.indexOf("redis") !== -1 ||
    lower.indexOf("worker") !== -1 ||
    lower.indexOf("invalid") !== -1 ||
    lower.indexOf("failed") !== -1 ||
    lower.indexOf("error") !== -1 ||
    lower.indexOf("timeout") !== -1 ||
    lower.indexOf("network") !== -1 ||
    raw.indexOf("<") !== -1
  ) {
    return fallback;
  }

  return raw;
}



// WEBPACK FOOTER //
// ./src/utils/autoFollowUpTemplateError.js